import { handleValidationChange } from "./CommonValidation";

export const validateTimesheet = (data, setIsError) => {

    var isValid = true;
    var isValidPhoto = true

    if(data.photo_proof === "") {
        handleValidationChange("photo", true, setIsError);
        isValidPhoto = false;
    } else {
        handleValidationChange("photo", false, setIsError);
        isValidPhoto = true;
    }

   

    isValid = isValid && isValidPhoto

    return isValid
  
}